import { render, staticRenderFns } from "./MerchantOrderHistory.vue?vue&type=template&id=6c9eee0c&"
import script from "./MerchantOrderHistory.vue?vue&type=script&lang=js&"
export * from "./MerchantOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports